export const emailValidate = [
  {
    type: 'email',
    message: 'Please input correct email address',
    trigger: [ 'blur', 'change', ], 
  },
  {
    required: true,
    message: 'Please input email address',
    trigger: 'blur', 
  },
]

export const passwordValidate = [
  {
    required: true,
    message: 'Please input password',
    trigger: 'blur', 
  }, 
]



// WEBPACK FOOTER //
// ./src/utils/validation.js